import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";
const api = {
    getInstructions: async () => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions;
        return new Promise((resolve) => {
            $.ajax({
                url: endpoint,
                type: 'GET',
                success: (result) => resolve({ success: true, content: result }),
                error: (xhr) => resolve({ success: false, error: xhr.responseText })
            });
        });
    },

    saveNewGroup: async (groupName) => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions + "/group";
        return new Promise((resolve) => {
            $.ajax({
                url: endpoint,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ group: groupName }),
                success: (result) => resolve({ success: true, content: result }),
                error: (xhr) => resolve({ success: false, error: xhr.responseText })
            });
        });
    },

    updateGroup: async (groupId, newName) => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions + `/group/${groupId}`;
        return new Promise((resolve) => {
          $.ajax({
            url: endpoint,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({ name: newName }),
            success: (result) => resolve({ success: true, content: result }),
            error: (xhr) => resolve({ success: false, error: xhr.responseText }),
          });
        });
      },

    deleteInstruction: async (instructionId) => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions + `/${instructionId}`;
        return new Promise((resolve) => {
            $.ajax({
                url: endpoint,
                type: 'DELETE',
                success: (result) => resolve({ success: true, content: result }),
                error: (xhr) => resolve({ success: false, error: xhr.responseText })
            });
        });
    },

    addInstruction: async (groupId, instructionData) => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions + `/${encodeURIComponent(groupId)}`;
    
        return new Promise((resolve) => {
            $.ajax({
                url: endpoint,
                type: 'POST',
                data: instructionData, // this is a FormData object
                processData: false,     // prevent jQuery from processing the data
                contentType: false,     // prevent jQuery from setting content type
                success: (result) => resolve({ success: true, content: result }),
                error: (xhr) => resolve({ success: false, error: xhr.responseText })
            });
        });
    },

    getInstructionFile: async (instructionId) => {
        const endpoint = BASE_URL + ENDPOINT_ROUTES.instructions + `/${encodeURIComponent(instructionId)}`;
    
        return new Promise((resolve) => {
            $.ajax({
                url: endpoint,
                type: 'GET',
                xhrFields: {
                    responseType: 'blob'  // Expect binary data
                },
                success: (data, status, xhr) => {
                    resolve({ success: true, file: data, contentType: xhr.getResponseHeader("Content-Type") });
                },
                error: (xhr) => {
                    resolve({ success: false, error: xhr.responseText });
                }
            });
        });
    }
};

export {api};
